import React, { useState } from "react";
 import { getUserData } from "../../auth";
import { useCreateWithdrawalMutation } from "../../apis/WithdrawalApi";

const DisplayComponent = ({ selectedItem,Balance }) => {
  // Hooks must be defined at the top level of the component
  const [balance, setBalance] = useState("");
  const [walletAddress, setWalletAddress] = useState("");
  const [isLoadingCreate, setIsLoadingCreate] = useState(false); // Track loading state
  const [requestWithdrowall, { isSuccess }] = useCreateWithdrawalMutation();

  // Get user data
  const userData = getUserData();
  const userId = userData?.uid || "";

  // If no `selectedItem`, render the fallback message
  if (!selectedItem) {
    return <p>Please select a withdrawal method to request a deposit.</p>;
  }

  const handleBalanceChange = (e) => {
    setBalance(e.target.value);
  };

  const handleWalletWithDrowChange = (e) => {
    setWalletAddress(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoadingCreate(true); // Set loading state to true when submitting

    // Create wallet request object to send

    const newBalance=Number(Balance) - parseFloat(balance) || 0
    const withdrowalResquest = {
      
      amountRequested: parseFloat(balance) || 0, // Ensure balance is a valid number
      oldBalance: Balance,  //balance 0
      newBalance: newBalance,   // balance 0
      status: "PENDING",
      dateRequested: new Date().toISOString(), 
      dateCompleted:'', 
      walletAddress: walletAddress, 
      paymentMethod: selectedItem?.name, 

     };

    try {
      // Call the RTK Query mutation to modify the wallet request
      await requestWithdrowall({
        Withdrawal: withdrowalResquest,  
        user_id: userId,  
      }).unwrap();
      
    //  console.log("Request sent successfully:", withdrowalResquest);
    } catch (error) {
   //   console.error("Failed to modify wallet request:", error);
    } finally {
      setIsLoadingCreate(false); // Reset loading state after request is finished
    }
  }; 
  return (
    <div className="col-xl-6 pe-xl-5">
      <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40 mt-2">
        <form onSubmit={handleSubmit}>
          {/* Wallet balance Input */}
          <div className="mb-24">
            <input
              type="number"
              className="common-input"
              placeholder="Enter withdrawal balance"
              value={balance}
              onChange={handleBalanceChange}
            />
          </div>
          <div className="mb-24">
            <input
              type="text"
              className="common-input"
              placeholder="Enter Wallet address"
              value={walletAddress}
              onChange={handleWalletWithDrowChange}
            />
          </div>
          {/* Submit Button */}
          <div className="mt-24">
            <button
              type="submit"
              className="btn btn-main py-18 px-32 rounded-8"
              disabled={isLoadingCreate} // Disable button when loading
            >
              {isLoadingCreate ? "Requesting..." : "Request withdrawal"}
            </button>
            {/* Show success message */}
            {isSuccess && (
              <p className="text-green-500 mt-4">
                Request well processed! You can see all withdrawal requests in "Withdrawal Requested."
              </p>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default DisplayComponent;
